"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalCSS = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
function useGlobalStyles(theme) {
    return (0, react_1.useMemo)(() => ({
        styles: {
            body: {
                backgroundColor: theme.palette.background.default,
                overscrollBehaviorY: "contain",
            },
        },
    }), [theme]);
}
function GlobalCSS() {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), (0, jsx_runtime_1.jsx)(material_1.GlobalStyles, Object.assign({}, useGlobalStyles(theme)))] }));
}
exports.GlobalCSS = GlobalCSS;
